export default "/images/gjensidige.png?3ca70c3c2b20308e4ccfc1db9844d6c6";